module.exports = __webpack_public_path__ + "img/hs.2d6e0590.svg";